import gql from 'graphql-tag'

export const media = gql`
	fragment mediamain on Media {
		name
		refreshTime
		tagId
		dateInterval {
			to
			from
		}
		timeInterval {
			to
			from
		}
		isActive
		stayActive
		animationType
		weekDays
		shopId
		withProducts {
      id
      name
    }
		img {
			id
			uid
			key
		}
		img16_9 {
			id
      uid
      key
    }
    imgMobile {
    	id
      uid
      key
    }
	}
`

export const listMedias = gql`
	fragment listMedias on MediaConnection {
		items {
			id
			mod_ver
			name
			fromTime
			timeInterval {
				from
			}
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
		total
		hasNextPage
	}
`
